import React, { useState, useMemo } from 'react';
import moment from 'moment';
import {
  Box,
  Typography,
  ListItem,
  ListItemIcon,
  Link,
  Tooltip,
  Icon,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

import Loading from './Loading';
import useStyles from './styles';

const CourseItem = props => {
  const classes = useStyles();
  const { item, isSelected, isLoading } = props;
  const [courseEmpty, setCourseEmpty] = useState(false);

  const courseLink = useMemo(() => {
    const {
      id: courseId,
      nextLesson,
      conclusionPercent,
      showBlockedLessons,
    } = item;
    let path = `/course/${courseId}/`;
    if (nextLesson) {
      const {
        certificate,
        daysToRelease,
        empty: emptyNextLesson,
        completed,
      } = nextLesson;

      const notShowBlockedLesson = daysToRelease > 0 && !showBlockedLessons;
      const certificateUnlocked =
        certificate ||
        certificate?.daysToRelease <= 0 ||
        certificate?.conclusionPercent <= conclusionPercent;

      if (emptyNextLesson || (notShowBlockedLesson && !certificateUnlocked)) {
        setCourseEmpty(true);
        path = '';
      } else {
        setCourseEmpty(false);
        const certificateIsNext = completed && certificateUnlocked;
        path = `/course/${courseId}/${
          certificateIsNext ? 'certificate' : nextLesson.id
        }`;
      }
    }
    return path;
  }, [item]);

  return isLoading ? (
    <Loading />
  ) : (
    <ListItem
      className={`${classes.container} ${item.locked ? 'locked' : ''}`}
      classes={{ selected: classes.listItemSelected }}
      selected={isSelected}
    >
      <Link
        className="list-courses-item-link"
        to={courseLink}
        underline="none"
        component={!item.locked || courseEmpty ? RouterLink : Box}
      >
        <ListItemIcon className="list-courses-item-icon">
          <img src={item.photo} alt={item.name} />
        </ListItemIcon>
        <Typography className="list-courses-item-text" variant="caption">
          {item.name}
        </Typography>
        {item.locked && (
          <Tooltip
            className="list-courses-item-lock"
            title={`Este curso será liberado em ${moment(
              item.releaseDate,
            ).format('DD/MM/YYYY')}`}
            placement="left"
          >
            <Icon fontSize="small">lock</Icon>
          </Tooltip>
        )}
        {courseEmpty && (
          <Tooltip
            className="list-courses-item-lock"
            title="Este curso ainda não possuí conteúdo disponível"
            placement="left"
          >
            <Icon fontSize="small">block</Icon>
          </Tooltip>
        )}
      </Link>
    </ListItem>
  );
};

export default CourseItem;
